<template>
  <div>
    <select-base
      ref="base"
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :invalido="invalido"
      :require="false"
      :label="'Quem fez a indicação?'"
      :label-select="'nome'"
      :carregar="carregarIndicacoes"
      :filtro-adicional="filtroAdicional"
      :placeholder="placeholder"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import api from '@/app-modulo/comercial/indicacao/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'IndicacaoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      value_: null,
      filtros: [
        {
          colunas: ['Nome'],
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.value_ = value
      },
      get() {
        return this.value_
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarIndicacoes() {
      return api.getIndicacoesResumidas(this.filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
